import { useSnackbar } from "notistack";
import { trimStart } from 'lodash';
import qs from 'qs';
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { withRouter } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import config from "../../config";
import { STATES, ROUTES } from "../../constants";
import Button from "@material-ui/core/Button";
// import ft_ic_nam from '../../../src/images/ft_ic_nam.png';
// import ft_ic_cit from '../../../src/images/ft_ic_cit.png';


const { autoLoadingHoasOnLoad } = config;
const { MANAGEMENT } = ROUTES;
const STATE_ANY = 'ANY';
const STATE_UNKNOWN = 'UNKNOWN';

const Filter = ({ location, onSubmit, hasChanges, totalItems }) => {
  const history = useHistory();

  const [address, setAddress] = useState('');
  const [initialized, setInitialized] = useState(false);
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const searchParameters = qs.parse(trimStart(location.search, '?'));
    syncStateWithProps();

    if (
      !initialized
      && Object.keys(searchParameters).length === 0
      && !autoLoadingHoasOnLoad
    ) {
      return;
    }

    onSubmit(searchParameters);
  }, [location.search]);

  useEffect(() => {
    setInitialized(true);
  }, []);

  const syncStateWithProps = () => {
    const {
      address: initialAddress,
      name: initialName,
      city: initialCity,
      state: initialState,
      zip: initialZip,
    } = qs.parse(trimStart(location.search, '?'));

    setAddress(initialAddress === undefined ? '' : initialAddress);
    setName(initialName === undefined ? '' : initialName);
    setCity(initialCity === undefined ? undefined : initialCity);
    setState(initialState === '' ? STATE_UNKNOWN : (initialState ? initialState : STATE_ANY));
    setZip(initialZip === undefined ? '' : initialZip);
  }

  const handleAddressChange = event => {
    setAddress(event.target.value);
  }
  const handleNameChange = event => {
    setName(event.target.value);
  }
  const handleCityChange = event => {
    setCity(event.target.value);
  }
  const handleStateChange = event => {
    setState(event.target.value);
  }
  const handleZipChange = event => {
    setZip(event.target.value);
  }
  const handleKeyUp = event => {
    if (event.key === 'Enter') {
      handleOnClick();
    }
  }

  const handleOnClick = () => {
    if (!hasChanges) {
      let stateFilter;
      switch (state) {
        case STATE_ANY:
          stateFilter = undefined;
          break;
        case STATE_UNKNOWN:
          stateFilter = '';
          break;
        default:
          stateFilter = state;
      }

      const stringParameters = qs.stringify({
        address: address || undefined,
        name: name || undefined,
        city: city || undefined,
        state: stateFilter,
        zip: zip || undefined,
      });
      history.push(`${MANAGEMENT}?${stringParameters}${location.hash}`);
    }
    else {
      enqueueSnackbar('You need to save or cancel the changes first.', { variant: 'error' });
    }
  }

  return <div>
    <div class="wht_box" style={{ paddingBottom: totalItems ? '10px' : 20 }}>
      <h4 class="hd_box">Search Management Companies</h4>
      <div class="form_item_fr">
        <div class="mb-2">
          <TextField size="small" fullWidth label="Name" variant="outlined" value={name} onChange={handleNameChange} onKeyUp={handleKeyUp} />
        </div>
      </div>
      <div class="form_item_fr">
        <div class="form-group">
          <TextField size="small" fullWidth label="Address" variant="outlined" value={address} onChange={handleAddressChange} onKeyUp={handleKeyUp} />
        </div>
      </div>

      <div class="form_item_fr">
        <div class="form-group">
          <TextField size="small" label="City" variant="outlined" value={city} onChange={handleCityChange} onKeyUp={handleKeyUp} />
        </div>
      </div>
      <div class="form_item_fr flex">
        <div class="btn-group dropup tw">
          <FormControl variant="outlined" size="small">
            <InputLabel>State</InputLabel>
            <Select
              value={state}
              onChange={handleStateChange}
            >
              <MenuItem value={STATE_ANY}>
                <em>-State-</em>
              </MenuItem>
              <MenuItem value={STATE_UNKNOWN}>
                <em>-UNKNOWN-</em>
              </MenuItem>
              {STATES.map(({ code, label }) => <MenuItem key={code} value={code}>{code}</MenuItem>)}
            </Select>
          </FormControl>
        </div>
        <div class="form_item_fr trd">
          <TextField size="small" label="Zip" variant="outlined" value={zip} onChange={handleZipChange} onKeyUp={handleKeyUp} />
        </div>
      </div>
      <div class="btn_box">
        <Button disabled={hasChanges} variant="contained" color="primary" onClick={handleOnClick}>
          Search
        </Button>
      </div>
      {totalItems ? <div className="form_item_fr">
        <div className="mb-2" style={{ padding: 0, color: '#2c4773', margin: 0, textAlign: 'center' }}>
          {totalItems} results found
        </div>
      </div> : ''}
    </div>
  </div>
}

export default withRouter(Filter);
